export const Experiments = {
  cookie_banner_optin_rate: 'cookie_banner_optin_rate',
};

export enum Variants {
  A = 'A',
  B = 'B',
}
